import { defineMessages } from 'react-intl';

export const messages: {
	feedbackTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rateExperience: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTitleNoCreate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rateExperienceNoCreate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTitleRemix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rateExperienceRemix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTitleSlides: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rateExperienceSlides: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTitleRovoInsights: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rateExperienceRovoInsights: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	summaryTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryPerformance: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryResponseQuality: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryUserExperience: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryOther: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryUnderstandingMyRequest: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryNumberOfQuestions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryPlanQuality: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categorySpeed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryEaseInEditing: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryInterfaceUsability: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryStepCompletion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	summaryPlaceholderText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	feedbackTitle: {
		id: 'smart-create-feedback.feedback-title',
		defaultMessage: 'Help us improve Create with Rovo',
		description: 'Title of a modal for providing feedback on the Create with Rovo feature.',
	},
	rateExperience: {
		id: 'smart-create-feedback.emoji-rating-selector.label',
		defaultMessage: 'Please rate your experience with Create with Rovo:',
		description:
			'Label for a field that allows the user to rate their experience on a 5-point emoji scale.  Only appears in the feedback modal for the Create with Rovo feature.',
	},
	feedbackTitleNoCreate: {
		id: 'smart-create-feedback.feedback-title-no-create',
		defaultMessage: 'Help us improve Rovo',
		description: 'Title of a modal for providing feedback on Rovo page editing.',
	},
	rateExperienceNoCreate: {
		id: 'smart-create-feedback.emoji-rating-selector.label-no-create',
		defaultMessage: 'Please rate your experience with Rovo:',
		description:
			'Label for a field that allows the user to rate their experience on a 5-point emoji scale.  Only appears in the feedback modal for Rovo page editing.',
	},
	feedbackTitleRemix: {
		id: 'smart-create-feedback.feedback-title-remix',
		defaultMessage: 'Help us improve Remix',
		description: 'Title of a modal for providing feedback on the Remix feature.',
	},
	rateExperienceRemix: {
		id: 'smart-create-feedback.emoji-rating-selector.label-remix',
		defaultMessage: 'Please rate your experience with Remix:',
		description:
			'Label for a field that allows the user to rate their experience on a 5-point emoji scale.  Only appears in the feedback modal for the Remix feature.',
	},
	feedbackTitleSlides: {
		id: 'smart-create-feedback.feedback-title-slides',
		defaultMessage: 'Help us improve Slides',
		description: 'Title of a modal for providing feedback on the Slides feature.',
	},
	rateExperienceSlides: {
		id: 'smart-create-feedback.emoji-rating-selector.label-slides',
		defaultMessage: 'Please rate your experience with Slides:',
		description:
			'Label for a field that allows the user to rate their experience on a 5-point emoji scale.  Only appears in the feedback modal for the Slides feature.',
	},
	feedbackTitleRovoInsights: {
		id: 'smart-create-feedback.feedback-title-rovo-insights',
		defaultMessage: 'Help us improve Rovo Insights',
		description:
			'Title of a modal for providing feedback on the Rovo Insights AI feature in JSM surveys.',
	},
	rateExperienceRovoInsights: {
		id: 'smart-create-feedback.emoji-rating-selector.label-rovo-insights',
		defaultMessage: 'Please rate your experience with Rovo Insights:',
		description:
			'Label for a field that allows the user to rate their experience with the Rovo Insights AI feature on a 5-point emoji scale.',
	},
	summaryTitle: {
		id: 'smart-create-feedback.summary-title',
		defaultMessage: 'Tell us more about your experience:',
		description:
			'Label for a freeform text field that allows the user to share feedback about their experience with Atlassian. Only appears in the feedback modal for the Create with Rovo feature.',
	},
	categoryTitle: {
		id: 'smart-create-feedback.category-title',
		defaultMessage: 'What category best describes your feedback? (optional)',
		description:
			'Label for a field that allows the user to select a category for their feedback.  Options are: "Performance", "Response quality", "User experience", "Other"',
	},
	categoryPerformance: {
		id: 'smart-create-feedback.category.performance',
		defaultMessage: 'Performance',
		description:
			'Category label for performance feedback.  Performance indicates "speed" (slow/fast) of the AI-generated response.',
	},
	categoryResponseQuality: {
		id: 'smart-create-feedback.category.response-quality',
		defaultMessage: 'Response quality',
		description:
			'Category label for response quality feedback.  Response quality indicates how good/bad or accurate/inaccurate the AI-generated response was.',
	},
	categoryUserExperience: {
		id: 'smart-create-feedback.category.user-experience',
		defaultMessage: 'User experience',
		description:
			'Category label for user experience feedback on the experience of creating AI-generated content.',
	},
	categoryOther: {
		id: 'smart-create-feedback.category.other',
		defaultMessage: 'Other',
		description: 'Category label for other feedback on AI-generated content creation.',
	},
	categoryUnderstandingMyRequest: {
		id: 'smart-create-feedback.category.understanding-my-request',
		defaultMessage: 'Understanding my request',
		description: "Category label for feedback about how well the AI understood the user's request.",
	},
	categoryNumberOfQuestions: {
		id: 'smart-create-feedback.category.number-of-questions',
		defaultMessage: 'Number of questions',
		description:
			'Category label for feedback about the number of questions asked during the space creation flow.',
	},
	categoryPlanQuality: {
		id: 'smart-create-feedback.category.plan-quality',
		defaultMessage: 'Plan quality',
		description: 'Category label for feedback about the quality of the AI-generated plan.',
	},
	categorySpeed: {
		id: 'smart-create-feedback.category.speed',
		defaultMessage: 'Speed',
		description: 'Category label for feedback about the speed/responsiveness of the AI.',
	},
	categoryEaseInEditing: {
		id: 'smart-create-feedback.category.ease-in-editing',
		defaultMessage: 'Ease in editing',
		description:
			'Category label for feedback about how easy it was to edit the AI-generated content.',
	},
	categoryInterfaceUsability: {
		id: 'smart-create-feedback.category.interface-usability',
		defaultMessage: 'Interface usability',
		description: 'Category label for feedback about the usability of the interface.',
	},
	categoryStepCompletion: {
		id: 'smart-create-feedback.category.step-completion',
		defaultMessage: 'Step completion',
		description: 'Category label for feedback about the completion of steps in the creation flow.',
	},
	summaryPlaceholderText: {
		id: 'smart-create-feedback.summary-placeholder-text',
		defaultMessage: 'What are we doing well? What could be improved?',
		description: 'Placeholder text for the summary field in the smart create feedback modal.',
	},
});
